/* Keeps the support amounts in ascending order without changing shared product data. */
(() => {
  const amount = (option) => Number((option.value || '').replace(/[^\d]/g, ''));

  const sortSupportAmounts = () => {
    const select = document.querySelector('variant-picker[data-product-handle="studla-ekko"] select.variant-option__select');
    if (!select) return;

    const options = Array.from(select.options);
    const sorted = [...options].sort((a, b) => amount(a) - amount(b));
    if (options.every((option, index) => option === sorted[index])) return;

    sorted.forEach((option) => select.add(option));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sortSupportAmounts, { once: true });
  } else {
    sortSupportAmounts();
  }

  document.addEventListener('shopify:section:load', sortSupportAmounts);
})();
